import React, { useEffect } from "react";
import "./index.scss";
import NewsReader from "../components/NewsReader";
import newsList from "../constants/news-preview/newsList";
import newsDetail from "../constants/news-preview/newsDetaile";
import { LeftOutlined } from "@ant-design/icons"
import shareIcon from "../assets/latestnews/share-icon.png"
import shareWx from "../assets/latestnews/share-wx.png"
import shareEmail from "../assets/latestnews/share-email.png"
import shareWb from "../assets/latestnews/share-wb.png"

function NewsDetail (props) {

    useEffect(() => {
        window.scrollTo(0, 0)
        const dom = document.getElementsByClassName("hb-top-bar")[0]
        dom.classList = ["hb-top-bar visible news-top-bar"]
        return () => {
            dom.classList = ["hb-top-bar"]
        }
    }, [])

    const toNewsDetail = (index) => {
        props.history.push({ pathname: "/news-detail", state: { newsId: index } })
        window.scrollTo(0,0)
    }

    return <div className="details-space">
        <div className="back" onClick={()=>props.history.push("/latest-news")}><LeftOutlined /></div>
        <NewsReader news={newsDetail[props.location.state.newsId]}/>
        {/* <div className="share-news">
            <div className="share-title">
                <span>分享</span>
                <img src={shareIcon} />
            </div>
            <img src={shareWx} className="share-type"/>
            <img src={shareWb} className="share-type"/>
            <img src={shareEmail} className="share-type"/>
        </div> */}
        <div className="detail-footer">
            <div className="check-more">
                <span className="text">查看更多</span>
                <span className="line"></span>
            </div>
            <div className="else-news">
                {
                   newsDetail.map((news, index) => {
                    if (props.location.state.newsId === index) {
                        return null
                    } else {
                        return <p className="news">
                            <span className="time">{news.header[0].split('年')[0] + '年'}</span>
                            <span className="footer-news-title" onClick={() => toNewsDetail(index)} style={{cursor: "pointer"}}>{news.title}</span>
                        </p>
                    }
                   })
                }
            </div>
        </div>
    </div>
}

export default NewsDetail